// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-dialog {
  width: 454px;
  height: 278px;
  position: absolute;
  left: calc(50% - 227px);
  top: calc(50% - 139px);
  overflow: hidden;
  opacity: 1;
  z-index: 20;
  border-radius: 5px;
  animation: popup 0.1s ease-in-out 0s 1;
}
.loading-dialog-title {
  width: 120px;
  height: 20px;
  font-size: 18px;
  opacity: 1;
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-weight: 500;
}
.loader {
  width: 200px;
  height: 140px;
  background: #979794;
  box-sizing: border-box;
  position: relative;
  border-radius: 8px;
  perspective: 1000px;
  transform: scale(0.8);
}
.loading-animation {
  width: 100%;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader:before {
  content: "";
  position: absolute;
  left: 10px;
  right: 10px;
  top: 10px;
  bottom: 10px;
  border-radius: 8px;
  background: #f5f5f5 no-repeat;
  background-size: 60px 10px;
  background-image: linear-gradient(#ddd 100px, transparent 0),
    linear-gradient(#ddd 100px, transparent 0),
    linear-gradient(#ddd 100px, transparent 0),
    linear-gradient(#ddd 100px, transparent 0),
    linear-gradient(#ddd 100px, transparent 0),
    linear-gradient(#ddd 100px, transparent 0);

  background-position: 15px 30px, 15px 60px, 15px 90px, 105px 30px, 105px 60px,
    105px 90px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}
.loader:after {
  content: "";
  position: absolute;
  width: calc(50% - 10px);
  right: 10px;
  top: 10px;
  bottom: 10px;
  border-radius: 8px;
  background: #fff no-repeat;
  background-size: 60px 10px;
  background-image: linear-gradient(#ddd 100px, transparent 0),
    linear-gradient(#ddd 100px, transparent 0),
    linear-gradient(#ddd 100px, transparent 0),
    linear-gradient(#ddd 100px, transparent 0);
  background-position: 50% 30px, 50% 60px, 50% 90px;
  transform: rotateY(0deg);
  transform-origin: left center;
  animation: paging 1s linear infinite;
}

@keyframes paging {
  to {
    transform: rotateY(-180deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/loadingDialog/loadingDialog.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B;;;;;8CAK4C;;EAE5C;cACY;EACZ,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B;;;8CAG4C;EAC5C,iDAAiD;EACjD,wBAAwB;EACxB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".loading-dialog {\n  width: 454px;\n  height: 278px;\n  position: absolute;\n  left: calc(50% - 227px);\n  top: calc(50% - 139px);\n  overflow: hidden;\n  opacity: 1;\n  z-index: 20;\n  border-radius: 5px;\n  animation: popup 0.1s ease-in-out 0s 1;\n}\n.loading-dialog-title {\n  width: 120px;\n  height: 20px;\n  font-size: 18px;\n  opacity: 1;\n  width: 100%;\n  text-align: center;\n  margin-top: 15px;\n  font-weight: 500;\n}\n.loader {\n  width: 200px;\n  height: 140px;\n  background: #979794;\n  box-sizing: border-box;\n  position: relative;\n  border-radius: 8px;\n  perspective: 1000px;\n  transform: scale(0.8);\n}\n.loading-animation {\n  width: 100%;\n  height: 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.loader:before {\n  content: \"\";\n  position: absolute;\n  left: 10px;\n  right: 10px;\n  top: 10px;\n  bottom: 10px;\n  border-radius: 8px;\n  background: #f5f5f5 no-repeat;\n  background-size: 60px 10px;\n  background-image: linear-gradient(#ddd 100px, transparent 0),\n    linear-gradient(#ddd 100px, transparent 0),\n    linear-gradient(#ddd 100px, transparent 0),\n    linear-gradient(#ddd 100px, transparent 0),\n    linear-gradient(#ddd 100px, transparent 0),\n    linear-gradient(#ddd 100px, transparent 0);\n\n  background-position: 15px 30px, 15px 60px, 15px 90px, 105px 30px, 105px 60px,\n    105px 90px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);\n}\n.loader:after {\n  content: \"\";\n  position: absolute;\n  width: calc(50% - 10px);\n  right: 10px;\n  top: 10px;\n  bottom: 10px;\n  border-radius: 8px;\n  background: #fff no-repeat;\n  background-size: 60px 10px;\n  background-image: linear-gradient(#ddd 100px, transparent 0),\n    linear-gradient(#ddd 100px, transparent 0),\n    linear-gradient(#ddd 100px, transparent 0),\n    linear-gradient(#ddd 100px, transparent 0);\n  background-position: 50% 30px, 50% 60px, 50% 90px;\n  transform: rotateY(0deg);\n  transform-origin: left center;\n  animation: paging 1s linear infinite;\n}\n\n@keyframes paging {\n  to {\n    transform: rotateY(-180deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
